"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitForumNotifications = splitForumNotifications;
const qms_1 = require("../constants/qms");
function splitForumNotifications(users) {
    const forumNotifications = users.find((user) => user.id === qms_1.QMS_SYSTEM_USER_ID) ?? null;
    const dialogs = users.filter((user) => user.id !== qms_1.QMS_SYSTEM_USER_ID);
    return { dialogs, forumNotifications };
}
